
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { ExampleBox, TextLink } from '../Components'
import { Box } from '@material-ui/core'
import wholeImg from './whole-screenshot.png'
import { Head } from '../Head'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Head title="Начало работы | Zerro" description="Инструкция поможет начать вести бюджет" mdxType="Head" />
    <h1>{`Начало работы`}</h1>
    <ExampleBox symbol="☝️" mdxType="ExampleBox">
  Меняя бюджеты в Zerro, вы меняете бюджеты в Дзен-мани, и наоборот.
    </ExampleBox>
    <h2>{`Подготовка`}</h2>
    <p>{`Zerro использует те же данные, что и Дзен-мани, но считает бюджеты по-другому. Поэтому, чтобы начать с чистого листа, давайте проверим пару вещей, которые могут вызвать ошибки:`}</p>
    <h3>{`1. Сбросьте остатки в категориях`}</h3>
    <p>{`В Дзен-мани остаток сгорает в конце месяца, а в Zerro наоборот — остаток бережно переносится из месяца в месяц. Если вы уже пользовались бюджетами Дзен-мани, возможно, в какой-то категории накопилось очень много денег. Чтобы убрать их:`}</p>
    <ul>
      <li parentName="ul">{`Переключитесь на предыдущий месяц.`}</li>
      <li parentName="ul">{`Найдите все категории с положительным остатком и сбросьте их в ноль. Для этого надо поставить им отрицательный бюджет (Zerro сам подскажет, какой).`}</li>
    </ul>
    <h3>{`2. Удалите будущие бюджеты`}</h3>
    <p>{`Дзен-мани умеет копировать бюджет на будущие месяцы. В Zerro такие бюджеты влияют на доступный остаток, поэтому для начала от них лучше избавиться.`}</p>
    <p>{`Вернитесь на текущий месяц, и посмотрите на цифру «Запланировано в будущем». Если она не равна нулю, значит впереди есть какие-то бюджеты. Найдите их и сбросьте в 0.`}</p>
    <h2>{`Распределяем деньги`}</h2>
    <p>{`Откройте текущий месяц и посмотрите на цифру «Осталось распределить» — именно столько денег нужно распределить по категориям (конвертам). Если какой-то категории не хватает, создайте её в Дзен-мани.`}</p>
    <Box component="img" maxWidth="100%" borderRadius={8} border="1px solid rgba(0,0,0,0.08)" boxShadow="0 8px 32px 0 rgba(0,0,0,0.16)" src={wholeImg} alt="Примерно так выглядит интерфейс внутри" mdxType="Box" />
    <h3>{`Как копить?`}</h3>
    <p>{`А как бы мы копили с бумажными конвертами? Завели бы отдельный конверт под каждую цель: отпуск, автомобиль, новый телефон и так далее. Работайте с Zerro точно так же. Создайте нужную категорию и регулярно откладывайте туда деньги.`}</p>
    <ExampleBox symbol="💡" mdxType="ExampleBox">
  <b>Скрыть категорию в Дзен-мани, но оставить в Zerro.</b>
  <ol>
    <li> Создайте категорию и укажите «Показывать в расходе»</li>
    <li> Задайте ей бюджет</li>
    <li> Снимите галочку «Показывать в расходе»</li>
  </ol>
  Теперь категория не появится в расходных категориях Дзен-мани, но будет видна
  в Zerro, потому что в этом «конверте» есть деньги.
    </ExampleBox>
    <h2>{`Следим за бюджетом`}</h2>
    <ul>
      <li parentName="ul">{`После каждой зарплаты заходите в Zerro и раскладывайте нераспределённые деньги по категориям.`}</li>
      <li parentName="ul">{`Периодически проверяйте, что в категориях достаточно денег. Для этого Zerro можно `}<a parentName="li" {...{
          "href": "https://t.me/zerroapp/10"
        }}>{`установить, как приложение`}</a>{`.`}</li>
      <li parentName="ul">{`Перемещайте деньги из одной категории в другую если нужно.`}</li>
      <li parentName="ul">{`Копите и `}<a parentName="li" {...{
          "href": "https://t.me/zerroapp/7"
        }}>{`создавайте новые цели`}</a>{`.`}</li>
      <li parentName="ul">{`Подписывайтесь на `}<a parentName="li" {...{
          "href": "https://t.me/zerroapp"
        }}>{`канал с обновлениями`}</a>{` и задавайте вопросы в `}<a parentName="li" {...{
          "href": "https://t.me/zerrochat"
        }}>{`чате`}</a>{`.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;